import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Escritos from "./pages/Escritos";
import Entrada from "./pages/Entrada";
import SobreMi from "./pages/SobreMi";
import Newsletter from "./pages/Newsletter";
import Panel from "./pages/Panel";
import Cursor from "./components/Cursor";
import AdminKeybind, { AdminLoginModal } from "./components/AdminKeybind";

function GlobalShell({ children }) {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <Cursor />
      <AdminKeybind onOpenModal={() => setModalOpen(true)} />
      <AdminLoginModal open={modalOpen} onClose={() => setModalOpen(false)} />
      {children}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <GlobalShell>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/escritos" element={<Escritos />} />
          <Route path="/entrada/:slug" element={<Entrada />} />
          <Route path="/sobre-mi" element={<SobreMi />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/panel" element={<Panel />} />
          {/* Discreet: /admin no longer exposes the panel */}
          <Route path="/admin" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </GlobalShell>
    </BrowserRouter>
  );
}
